export default "__VITE_ASSET__MfvoWY2D__"